import { createStore } from "redux";
import { Customer, Order, Session } from "../models";
import { removeUserSession } from "../shared/utils/LocalSessionHandler";
import { ActionType } from "./actions";
import { IAction } from "./IAction";

export interface IState {
    customer?: Customer;
    session?: Session;
    order?: Order;
    isLoggedIn: boolean;
}

export const initialState: IState = {
    customer: undefined,
    session: undefined,
    order: undefined,
    isLoggedIn: false,
};

export const store = createStore(appReducer, initialState);

// Reducer
export default function appReducer(state = initialState, action: IAction) {
    switch (action.type) {
        case ActionType.SET_CUSTOMER: {
            return {
                ...state,
                customer: action.payload,
            };
        }
        case ActionType.SET_SESSION: {
            return {
                ...state,
                session: action.payload,
                isLoggedIn: true,
            };
        }
        case ActionType.LOG_OUT_RESET_STATE: {
            removeUserSession(); // remove from browser session storage
            return {
                ...action.payload,
            };
        }
        case ActionType.ADD_ORDER:
        case ActionType.REMOVE_ORDER: {
            return {
                ...state,
                order: action.payload,
            };
        }
        default:
            return state;
    }
}
